import React, { ReactElement } from 'react';
import InvoiceList from './InvoiceList';

const InvoiceTab = (): ReactElement => {
    return <InvoiceList />;
};

export default InvoiceTab;
